import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import CandleCanvas from "./components/CandleCanvas";
import Nav from "./components/Nav";
import Landing from "./components/Landing";
import AuthModal from "./components/AuthModal";
import CheckoutModal from "./components/CheckoutModal";
import MemberDash from "./components/MemberDash";
import LiveIndicator from "./components/LiveIndicator";
import { PaymentSuccess, PaymentCancel } from "./components/PaymentPages";
import Ticker from "./components/Ticker";
import TrialBanner from "./components/TrialBanner";
import AdminPanel from "./components/AdminPanel";
import AIScanner from "./components/AIScanner";
import Results from "./components/Results";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CandleCanvas />
          <div className="app-layer">
            <Ticker />
            <TrialBanner />
            <Routes>
              <Route path="/" element={<><Nav /><Landing /></>} />
              <Route path="/dashboard" element={<MemberDash />} />
              <Route path="/live" element={<LiveIndicator />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/scanner" element={<AIScanner />} />
              <Route path="/results" element={<><Nav /><Results /></>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </div>
          <AuthModal />
          <CheckoutModal />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
